import React, { useState, useEffect, useRef } from "react";
import styles from "styles/genai/Edetail.module.scss";
import LinkButton from "components/LinkButton";
import PrimaryButton from "components/PrimaryButton";
import tick from "img/genai/tick.svg";
import suggestion from "img/genai/suggestions.svg";
import viewport from "img/genai/viewport.svg";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import bulbIcon from "img/genai/bulb.svg";
import { PreviewModal } from "./../PreviewModal";
import sampleImg from "img/genai/images/component1.png";
import placeHoldimg from "img/placehoder0.png";
import { slideRecommendation } from "components/genAi/api/genapi";
import CircularProgressBar from "Uitls/CircularProgressBar";
import { toast } from "react-toastify";
import NoDataFound from "components/NoDataFound";
import NetworkErr from "components/NetworkErr";
import SlideRecLoader from "components/genAi/utils/SlideRecLoader";
export const SlideRecom = ({
  setIsSlideRecomModalOpen,
  handleProceedSlides,
  selectedCount,
  selectedSlide,
  SetSlideTextShow,
  slidePopup
}) => {
  const [showModal, setShowModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSelectedSlide, setActiveSelectedSlide] = useState(null);
  const [selectedRecommendedSlides, setSelectedRecommendedSlides] = useState(
    []
  );
  const [activeTooltip, setActiveTooltip] = useState(null);
  const abortControllerRef = useRef(null);
  const{setShowSlideMsg}=slidePopup;
  const fetchRecommendations = async () => {
    if (!selectedSlide?.assetId || !selectedSlide?.slideIds) {
      setError("Missing required slide data");
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await slideRecommendation(
        selectedSlide.assetId,
        selectedSlide.slideIds
      );


      setApiData(response);

      // Set first selected slide as active by default
      if (response.selected && response.selected.length > 0) {
        setActiveSelectedSlide(response.selected[0].pageId);
      }
    } catch (err) {
      setError(err.message);
      console.error("Failed to fetch recommendations:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelApiCall = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      console.log("API request cancelled");
    }
    setIsLoading(false);
    setIsSlideRecomModalOpen(false);
  };
  // Fetch slide recommendations when component mounts
  useEffect(() => {
    fetchRecommendations();

    // Cleanup function to cancel API call when component unmounts
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [selectedSlide]);

  // Transform selected slides to matchedData structure for left side
  const matchedData = {
    slides: selectedSlide.slideIds.map((slideId, index) => {
      const signedUrlObj = selectedSlide.signedUrls?.find(
        (url) => url.pageId === slideId
      );
      return {
        slideLabel: selectedSlide.slidenums?.[index] || `Slide_${index + 1}`,
        signedUrl: signedUrlObj?.signedUrl || " ",
        pageId: slideId,
        pageNo: index + 1,
      };
    }),
    modules: [],
  };

  // Get recommendations for currently active selected slide
  const getCurrentRecommendations = () => {
    if (!apiData?.recommendations || !activeSelectedSlide) return [];

    return apiData.recommendations
      .filter((rec) => rec.closestSelected?.pageId === activeSelectedSlide)
      .slice(0, 10); // Show more recommendations, user can scroll
  };

  // Transform recommendations to match your JSX structure for right side
  const transformedRecommendedData = getCurrentRecommendations().map((rec) => {
    const signedUrlObj = selectedSlide.signedUrls?.find(
      (url) => url.pageId === rec.pageId
    );
    return {
      id: rec.pageId,
      image: rec.signedUrl || placeHoldimg,
      slidenum: `Slide_${rec.pageNo}`,
      isdisabled: false,
      pageNo: rec.pageNo,
      claims: [],
      profile: rec.profile,
      why: rec.why,
      score: rec.score,
    };
  });

  // Handle recommended slide selection
  const handleRecommendedSlideSelect = (slideId) => {
    setSelectedRecommendedSlides((prev) => {
      if (prev.includes(slideId)) {
        // Deselect if already selected
        return prev.filter((id) => id !== slideId);
      } else {
        const wouldBeTotalCount = selectedCount + prev.length + 1;

        if (wouldBeTotalCount > 5) {
          const toastId = "limit-warning";
          if (!toast.isActive(toastId)) {
            toast.warning("Maximum of 5 slides can be selected at once.", {
              toastId,
              position: "top-right",
              autoClose: 3000,
            });
          }
          return prev;
        }

        return [...prev, slideId];
      }
    });
  };
  // Handle proceed with selected recommendations
  const handleProceedWithSelections = () => {
    SetSlideTextShow(false);
    setShowSlideMsg(true)
    // Get complete data for selected recommended slides
    const selectedRecommendedSlidesData = selectedRecommendedSlides.map(
      (slideId) => {
        const recommendedSlide = apiData?.recommendations?.find(
          (rec) => rec.pageId === slideId
        );
        const signedUrlObj = selectedSlide.signedUrls?.find(
          (url) => url.pageId === slideId
        );

        return {
          pageId: slideId,
          pageNo: recommendedSlide?.pageNo || 0,
          signedUrl: recommendedSlide?.signedUrl || placeHoldimg,
          slidenum: recommendedSlide
            ? `Slide_${recommendedSlide.pageNo}`
            : `Slide_${slideId}`,
          profile: recommendedSlide?.profile,
          why: recommendedSlide?.why,
          score: recommendedSlide?.score,
        };
      }
    );

    // Pass both the IDs and the complete data
    handleProceedSlides(
      selectedRecommendedSlides,
      selectedRecommendedSlidesData
    );
  };

  const preventContextMenu = (e) => e.preventDefault();

  const processPreviewData = (data) => {
    if (!data) return null;

    if (data.image && data.pageNo) {
      return {
        pageDetails: [
          {
            signedUrl: data.image,
            pageNo: data.pageNo,
          },
        ],
      };
    }

    if (Array.isArray(data.pageDetails)) {
      return data;
    }

    return null;
  };

  const handleImageClick = (slideOrEdetail) => {
    const normalized = processPreviewData(slideOrEdetail);
    if (!normalized) return;
    setPreviewData(normalized);
    setShowModal(true);
  };

  // Calculate total selected count
  const totalSelectedCount = selectedCount + selectedRecommendedSlides.length;

  const RecHeader = () => {
    return (
      <>
        <article className={`${styles.modalHead} ${styles["customPadding"]}`}>
          <span className={styles.headerSlideRec}>
            Recommended Slides based on selected Slide
          </span>
          <span className={styles.secondHeaderSlideRec}>
            Note: The slides shown below are system-recommended based on the
            currently selected slide. Selecting from these is optional, and you
            can choose up to 5 in total.
            <br />
            Disclaimer: These are AI generated recommendations. Please review.
          </span>
        </article>
      </>
    );
  };
  const RecBottom = () => {
    return (
      <article className={styles.modalBottom}>
        <div>
          Selected <strong>{totalSelectedCount}</strong>/5
        </div>
        <div>
          <div className={styles.modalBottomRec}>
            <LinkButton
              title="CANCEL"
              handleClick={() => {
                cancelApiCall();
              }}
            />
            <PrimaryButton
              fontSize="12px"
              title="PROCEED WITH SELECTION"
              handleClick={handleProceedWithSelections}
              disabled={selectedRecommendedSlides.length === 0}
            />
          </div>
        </div>
      </article>
    );
  };
  return (
    <>
      <div className={styles.modalOverlay}>
        <div
          className={`${styles.modalContent} ${styles["customWidth"]}`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Show loader while API is loading */}
          {isLoading ? (
            <>
              <RecHeader />
              <article className={styles.ContentSlideRec}>
                <SlideRecLoader />
              </article>
              <RecBottom />
            </>
          ) : error ? (
            <>
              <RecHeader />
              <article className={styles.ContentSlideRec}>
                <NetworkErr
                  title="Error in loading"
                  description="We encountered an unexpected error that prevented us from completing the process."
                  showButton={true}
                  buttonText="Try Again"
                  onButtonClick={() => fetchRecommendations()}
                />
              </article>
              <article className={styles.modalBottom}>
                <div></div>
                <div>
                  <div className={styles.modalBottomRec}>
                    <LinkButton
                      title="CLOSE"
                      handleClick={() => setIsSlideRecomModalOpen(false)}
                    />
                  </div>
                </div>
              </article>
            </>
          ) : (
            <>
              <RecHeader />
              <article className={styles.ContentSlideRec}>
                {/* Left Side - Selected Slides */}
                <div className={styles.contASlideRec}>
                  {matchedData.slides.map((slide, i) => (
                    <div
                      key={slide.pageId || i}
                      className={`${styles.sliderecBox}`}
                      onClick={() => setActiveSelectedSlide(slide.pageId)}
                    >
                      <span
                        className={`${styles.analysebox} ${
                          activeSelectedSlide === slide.pageId
                            ? styles.activeSlide
                            : ""
                        }`}
                      >
                        <img
                          className={styles.imgSlidecont}
                          src={slide.signedUrl}
                          alt={slide.slideLabel}
                          onContextMenu={preventContextMenu}
                        />
                        <span className={styles.analyseText}>
                          {slide.slideLabel}
                        </span>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Right Side - Recommended Slides */}
                <div className={styles.contBSlideRec}>
                  <div className={styles.innerBox}>
                    <div className={styles.recommendedContainer}>
                      {transformedRecommendedData.length > 0 ? (
                        transformedRecommendedData.map((ele) => (
                          <article
                            key={ele.id}
                            className={`${styles.eslidesub} ${
                              styles["imgRec"]
                            } ${
                              selectedRecommendedSlides.includes(ele.id)
                                ? styles.selected
                                : ""
                            }`}
                            onClick={() => handleRecommendedSlideSelect(ele.id)}
                          >
                            {/* Selected tick mark */}
                            {selectedRecommendedSlides.includes(ele.id) && (
                              <div
                                className={`${styles.selectedTick} ${styles["slideRec"]}`}
                              >
                                <img src={tick} alt="Selected" />
                              </div>
                            )}

                            <div
                              className={`${styles.imageContainer} ${styles["slideRecom"]}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleImageClick(ele);
                              }}
                            >
                              <img
                                className={`${styles.cardsimg} ${styles["slideRec"]}`}
                                src={ele.image}
                                alt={`Slide ${ele.pageNo}`}
                                style={{ objectFit: "fill" }}
                                onContextMenu={preventContextMenu}
                              />
                              <div
                                className={styles.previewOverlay}
                                onContextMenu={preventContextMenu}
                              >
                                <article className={styles.previewBox}>
                                  <img src={viewport} alt="view" />
                                  <span>Preview</span>
                                </article>
                              </div>
                            </div>

                            <article
                              className={`${styles.eslidebottom} ${
                                styles["slideRec"]
                              } ${
                                selectedRecommendedSlides.includes(ele.id)
                                  ? styles.selectedSlide
                                  : ""
                              }`}
                            >
                              <div className={`${styles.leftecard}`}>
                                <span className={styles.cardstatus}>
                                  <strong>{ele.slidenum}</strong>
                                </span>
                              </div>
                              <div className={styles.rightecard}>
                                <StyledTooltip
                                  title={ele?.why || ""}
                                  open={activeTooltip === ele.id}
                                  arrow
                                  placement="bottom-start"
                                >
                                  <span
                                    onMouseEnter={() =>
                                      setActiveTooltip(ele.id)
                                    }
                                    onMouseLeave={() => setActiveTooltip(null)}
                                  >
                                    <img
                                      className={styles.iconSlideRec}
                                      src={bulbIcon}
                                      alt="info"
                                    />
                                  </span>
                                </StyledTooltip>
                              </div>
                            </article>
                          </article>
                        ))
                      ) : (
                        <div className={styles.noDataFoundContainer}>
                          <NoDataFound
                            customClass={true}
                            customClassNoResult={true}
                            title={"No recommendations"}
                            positioning="top: 47%; left: 63%;"
                            Description={
                              "No appropriate slides found for the selected slide"
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </article>

              <RecBottom />
            </>
          )}
        </div>
      </div>

      {previewData && (
        <PreviewModal
          show={showModal}
          onClose={() => setShowModal(false)}
          previewData={previewData}
        />
      )}
    </>
  );
};

const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px 12px",
    borderRadius: "4px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "0px",
    marginBottom: "8px",
    boxShadow: "0px 0px 8px 0px #231F201F",
    width: "220px",
    height: "auto",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "2px",
    borderColor: "#fff",
    transform: "scale(1)",
  },

  popper: {
    zIndex: 9999,
    '&[x-placement*="bottom"] .MuiTooltip-tooltip': {
      marginTop: "8px",
      marginBottom: "0px",
    },
    '&[x-placement*="top"] .MuiTooltip-tooltip': {
      marginTop: "0px",
      marginBottom: "8px",
    },
  },
})(Tooltip);
